import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { ISearchResult } from "../../../models";
import { FetchError, GetSearchResultsDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useSearchRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function searchRequest({
    signal,
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.search.getSearchResults>>): Promise<GetSearchResultsDto> {
    const accessToken = await getAccessToken();
    const [{ query, filter }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/search?query=${query}&filter=${filter}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      signal,
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { searchRequest };
};

const useSearch = (query: string, filter: string, enabled: boolean) => {
  const { searchRequest } = useSearchRequest();

  return useQuery({
    queryKey: queryKeys.search.getSearchResults(query, filter),
    queryFn: searchRequest,
    select: (data): ISearchResult[] => {
      return data.searchResults;
    },
    enabled: enabled,
  });
};

export { useSearch };
